import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { EmojiTitleButtonComponentProps } from '../src/emoji-title/__types__/EmojiTitleButton.ts';

export const EmojiTitleButtonLoader: LoadableType<
	Omit<EmojiTitleButtonComponentProps, 'emojiTitleState' | 'pageTreeStateUpdater'>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcemoji-titleEmojiTitleButton" */ '../src/emoji-title/EmojiTitleButton.tsx'
			)
		).EmojiTitleButton,
});
